import type { ApiClient } from '@glomopay/utils';

import { tenantConfigSchema, type TTenantConfigResponse } from './tenant.schema';
import { DEFAULT_BRANDING } from './tenant.defaults';
import type { TenantBranding, TTenantConfig } from './tenant.types';

export const fetchTenantConfig = async (apiClient: ApiClient, domain: string): Promise<TTenantConfig> => {
  const response = (await apiClient.get('/v1/tenant/resolve', { domain }, tenantConfigSchema)) as TTenantConfigResponse;
  const rawBranding = response.branding;

  if (!rawBranding && response.isWhitelabel) {
    throw new Error('Whitelabel tenant is missing branding configuration');
  }

  const branding: TenantBranding = rawBranding
    ? { ...DEFAULT_BRANDING, ...rawBranding, theme: { ...DEFAULT_BRANDING.theme, ...(rawBranding.theme ?? {}) } }
    : DEFAULT_BRANDING;

  return {
    isWhitelabel: response.isWhitelabel,
    authMode: response.authMode,
    selfServeOnboardingEnabled: response.selfServeOnboardingEnabled,
    branding,
  };
};
